import image from "../../../assets/logo.svg"
import BorderWrapper from "../../../components/ui/wrappers/BorderWrapper";
const Propaganda = () => {
    return (<BorderWrapper tailwindClass="p-4 max-w-[500px]">
        <p className="text-center text-lg md:text-xl md:text-left">PretUp, le placement qui allie performance, transparence, accessibilité et impact sociétal</p>
    </BorderWrapper>)
}

export default Propaganda;